<template>
  <AppClientSchoolLayout title="学生成績">
    <template #header>
    </template>

    <div class="md:flex justify-center items-start p-6">
      <div class="bg-white m-4 shadow rounded-lg flex-none h-auto max-w-xs">
        <dl class="p-4">
          <dt class="text-md font-medium text-gray-500">
            模試名
          </dt>
          <dd class="mt-2 mx-4 text-md text-gray-900">
            {{ examination.title }}
          </dd>
        </dl>
        <div class="border-t border-gray-200"></div>
        <dl class="pt-4 px-4">
          <dt class="text-md font-medium text-gray-500">
            ユーザID
          </dt>
          <dd class="mt-2 mx-4 text-md text-gray-900">
            {{ user.id }}
          </dd>
        </dl>
        <dl class="pt-4 px-4">
          <dt class="text-md font-medium text-gray-500">
            学籍番号
          </dt>
          <dd class="mt-2 mx-4 text-md text-gray-900">
            {{ user.student_id }}
          </dd>
        </dl>
        <dl class="pt-4 px-4">
          <dt class="text-md font-medium text-gray-500">
            学年
          </dt>
          <dd class="mt-2 mx-4 text-md text-gray-900">
            {{ convertToGrade(user.service_years) }}
          </dd>
        </dl>
        <dl class="py-4 px-4">
          <dt class="text-md font-medium text-gray-500">
            名前
          </dt>
          <dd class="my-2 mx-4 text-md text-gray-900">
            {{ user.name }}
          </dd>
        </dl>
      </div>

      <div class="bg-white m-4 shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 sm:px-6">
          <h4 class="text-lg font-medium text-gray-900">
            成績詳細
          </h4>
        </div>
        <div class="border-t border-gray-200">
          <dl>
            <div class="grid grid-cols-1 sm:grid-cols-10 bg-white px-4 py-5">
              <div class="display:flex col-span-5">
                <dt class="text-md font-medium text-gray-500 ml-5 mb-4">
                  成績
                  <div
                    v-for="(examinationType, key) in EXAMINATION_TYPES"
                    :key="key">
                    <div
                      v-if="isFinishSelectType(examinationType.index)"
                      class="mt-2 grid grid-cols-4 items-center text-center">
                      <p class="inline text-gray-900 text-right">
                        {{ examinationType.label }}：
                      </p>
                      <p
                        class="inline font-black text-xl sm:text-2xl text-right mr-2">
                        {{ getScore(examinationType.index) }}
                      </p>
                      <p class="inline text-left ml-2">
                        / {{ examinationType.questionsCount }}
                      </p>
                      <p :class="getRankColor(getRank(examinationType.index))">
                        {{ getRank(examinationType.index) }}
                      </p>
                    </div>
                    <div
                      v-else
                      class="my-4 grid grid-cols-4 items-center">
                      <p class="inline text-gray-900 text-right">
                        {{ examinationType.label }}：
                      </p>
                      <p class="inline font-black text-md ml-2 text-right">
                        未実施
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="props.progresses.length"
                    class="mt-6 grid grid-cols-4 items-center text-center">
                    <p class="inline text-gray-900 text-right">
                      合計：
                    </p>
                    <p class="inline font-black text-2xl sm:text-4xl text-right mr-2">
                      {{ getTotalScore() }}
                    </p>
                    <p class="inline text-left ml-2">
                      / 200
                    </p>
                    <p :class="getRankColor(calcRank(getTotalScore(), 200))">
                      {{ calcRank(getTotalScore(), 200) }}
                    </p>
                  </div>
                  <div
                    v-else
                    class="mt-8 grid grid-cols-4 items-center">
                    <p class="inline text-gray-900 text-right">
                      合計：
                    </p>
                    <p class="inline font-black text-md ml-2 text-right">
                      未実施
                    </p>
                  </div>
                </dt>
                <dt class="text-md font-medium text-gray-500 ml-5 mt-8 mb-4">
                  順位
                  <div
                    class="mt-2 grid grid-cols-4 items-center text-center">
                    <p
                      class="inline text-gray-900 text-right">
                      校内：
                    </p>
                    <p
                      v-if="schoolRanking"
                      class="inline font-black text-2xl sm:text-4xl text-right mr-2">
                      {{ schoolRanking }}位
                    </p>
                    <p
                      v-if="schoolRanking"
                      class="inline text-left ml-2">
                      / {{ studentsCount }}人中
                    </p>
                    <p
                      v-else
                      class="inline font-black text-md ml-2 text-right">
                      未集計
                    </p>
                  </div>
                  <div
                    class="mt-6 grid grid-cols-4 items-center text-center">
                    <p
                      class="inline text-gray-900 text-right">
                      全国：
                    </p>
                    <p
                      v-if="ranking"
                      class="inline font-black text-2xl sm:text-4xl text-right mr-2">
                      {{ ranking }}位
                    </p>
                    <p
                      v-if="ranking"
                      class="inline text-left ml-2">
                      / {{ usersCount }}人中
                    </p>
                    <p
                      v-else
                      class="inline font-black text-md ml-2 text-right">
                      未集計
                    </p>
                  </div>
                </dt>
              </div>
              <dd class="grid mt-6 sm:col-span-5 text-sm text-gray-900 mr-8">
                <BarChart :chart-data="getBarData()" />
              </dd>
              <div
                v-if="isBeforeDate(examination.result_announcement_date)"
                class="ml-5 mt-2 grid sm:col-span-5 text-sm text-red-500">
                <p>
                  ※全国順位と平均点は後日集計予定となります。
                </p>
                <p>
                  成績集計開始日時：{{ formatDate(examination.result_announcement_date) }}
                </p>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-6 mt-4">
              <div
                class="flex">
                <a
                  class="bg-yellow-500 block ml-5 py-3 px-5 lg:hover:bg-yellow-400 active:bg-green-400 duration-300 text-white rounded-lg"
                  :href="route('school.commentary.answer-list', { examination: examination.id, userId: user.id })"
                  target="_blank">
                  解答一覧
                </a>
              </div>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </AppClientSchoolLayout>
</template>

<script setup>

import moment from 'moment'
import Swal from 'sweetalert2'
import { Inertia } from '@inertiajs/inertia'
import { Chart, registerables } from 'chart.js'
import { BarChart } from 'vue-chart-3'
import formatDate from '@/actions/format/date'
import convertToGrade from '@/actions/serviceYears/convert'
import AppClientSchoolLayout from '@/Layouts/AppClientSchoolLayout'
import { EXAMINATION_TYPES, getExaminationType } from '@/Constants/examinationTypes'

Chart.register(...registerables)

const props = defineProps({
  examination: {
    type: Object,
    default: () => { },
  },
  user: {
    type: Object,
    default: () => { },
  },
  progresses: {
    type: Array,
    default: () => [],
  },
  scores: {
    type: Array,
    default: () => [],
  },
  ranking: {
    type: Number,
    default: null,
  },
  usersCount: {
    type: Number,
    default: 0,
  },
  schoolRanking: {
    type: Number,
    default: null,
  },
  studentsCount: {
    type: Number,
    default: 0,
  },
})

const filterExamProgress = (type) => props.progresses.filter(progress => (progress.examination_type === type))

const isFinishSelectType = (type) => filterExamProgress(type).length

const getScore = (type) => {
  const prog = filterExamProgress(type).pop()
  if (prog && prog.score) return prog.score
  return 0
}

const getTotalScore = () => {
  let totalScore = 0

  Object.values(EXAMINATION_TYPES).forEach(examinationType => {
    const prog = filterExamProgress(examinationType.index).pop()

    if (prog && prog.score) {
      totalScore += prog.score
    }
  })
  return totalScore
}

const getScorePercentage = (type) => {
  const prog = filterExamProgress(type).pop()
  if (!prog || !prog.score) return 0

  // 問題種別ごとに問題数が違うため、問題数をもとに得点率を計算する
  return prog.score * (100 / (getExaminationType(type).questionsCount))
}

const getAverageScorePercentage = (type) => {
  const score = props.scores
    .filter(value => (value.examination_type === type))
    .pop()

  if (!score || !Object.keys(score).some(value => value === 'average_score')) return 0

  // 問題種別ごとに問題数が違うため、問題数をもとに平均得点率を計算する
  return score.average_score * (100 / (getExaminationType(type).questionsCount))
}

const calcRank = (val, maxVal) => {
  const percentage = (val * 100) / maxVal

  if (percentage >= 80) return 'A'
  if (percentage >= 60) return 'B'
  if (percentage >= 40) return 'C'
  return 'D'
}

const getRank = (type) => {
  const prog = filterExamProgress(type).pop()
  if (!prog || !prog.score) return calcRank(0, 100)

  let intScore = parseInt(prog.score, 10)

  // 問題種別ごとに問題数が違うため、100点満点とした時の得点に平す
  intScore *= (100 / (getExaminationType(type).questionsCount))
  return calcRank(intScore, 100)
}

const getRankColor = (rank) => {
  switch (rank) {
    case 'A':
      return 'text-yellow-500 inline font-black underline flex items-center text-4xl text-left'
    case 'B':
      return 'text-green-500 inline font-black underline flex items-center text-4xl text-left'
    case 'C':
      return 'text-yellow-300 inline font-black underline flex items-center text-4xl text-left'
    default:
      return 'text-blue-500 inline font-black underline flex items-center text-4xl text-left'
  }
}

const getBarData = () => {
  const barData = {
    labels: [
      EXAMINATION_TYPES.compulsory.label,
      EXAMINATION_TYPES.general.label,
      EXAMINATION_TYPES.practice.label,
    ],
    datasets: [
      {
        type: 'bar',
        label: '得点(%)',
        data: [
          getScorePercentage(EXAMINATION_TYPES.compulsory.index),
          getScorePercentage(EXAMINATION_TYPES.general.index),
          getScorePercentage(EXAMINATION_TYPES.practice.index),
        ],
        fill: true,
        order: 0,
        backgroundColor: [
          'rgba(54, 162, 235, 0.2)',
        ],
        borderColor: [
          'rgb(54, 162, 235)',
        ],
        borderWidth: 2,
      },
      {
        type: 'bar',
        label: '平均点(%)',
        data: [
          getAverageScorePercentage(EXAMINATION_TYPES.compulsory.index),
          getAverageScorePercentage(EXAMINATION_TYPES.general.index),
          getAverageScorePercentage(EXAMINATION_TYPES.practice.index),
        ],
        fill: false,
        order: 1,
      },
    ],
  }

  return barData
}

const isBeforeDate = (data) => {
  const now = moment()
  const momentDate = moment(data)
  return now.isBefore(momentDate)
}

</script>
